module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Compilation-aa7b59d1f9935d5ca2740ba255f7620a.svg";